var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('el-carousel',{staticClass:"carousel",attrs:{"trigger":"click","height":"490px","arrow":"never"}},_vm._l((_vm.banners),function(item){return _c('el-carousel-item',{key:item},[_c('img',{staticClass:"bannerImg",attrs:{"src":item}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b1ab326","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopCarousel.vue
// module id = null
// module chunks = 